import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=2aded5a0&scoped=true"
import script from "./filter-item.vue?vue&type=script&lang=ts"
export * from "./filter-item.vue?vue&type=script&lang=ts"
import style0 from "./filter-item.vue?vue&type=style&index=0&id=2aded5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aded5a0",
  null
  
)

export default component.exports